exports.REGEX = require("./regex");
exports.LANGUAGE = require("./language.json");
exports.DIRECTION = require("./direction");
exports.MESSAGE = exports.M = require("./message");
exports.COUNTRY_CODE = {
  IRELAND: "IE",
  GREAT_BRITAIN: "GB",
};
